import classNames from "classnames";
import React from "react";

const classNamePrefix = "Container";

type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

export const Container = React.forwardRef(
  (props: ContainerProps, ref?: React.ForwardedRef<HTMLDivElement>) => {
    const { children, className, ...restProps } = props;
    return (
      <div
        ref={ref}
        {...restProps}
        className={classNames(className, classNamePrefix)}
      >
        <div>{children}</div>
      </div>
    );
  },
);
